import { VStack } from '@vivaahealth/design-system';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import * as api from '../../../api';
import TextData from '../../../components/TextData';

interface SurgicalHistoryProps {
  field: api.PrevisitFormField.PrevisitFormFieldWithConfig;
}

const SurgicalHistory = ({ field }: SurgicalHistoryProps) => {
  const { t } = useTranslation('review');

  const procedures = JSON.parse(
    field.value,
  ) as api.Procedure.PrevisitProcedure[];

  return (
    <VStack gap={16}>
      {procedures.map(({ id, name, dateMonth, dateYear }) => {
        const month = dateMonth ? moment(dateMonth, 'M').format('MMMM') : null;
        const date = month ? `${month} ${dateYear}` : dateYear;

        return (
          <TextData
            key={id}
            label={t('Surgical history')}
            value={t('surgeryName', {
              name,
              date,
            })}
          />
        );
      })}
    </VStack>
  );
};

export default SurgicalHistory;
